import { Box, Select, MenuItem, IconButton } from '@mui/material';

import { APModal } from "../Styles/style";
import {
  getProjects,
  updateCompanyData,
  getProjectDetailById,
  updateAssociateData,
} from "../services/apiHandler";
import { useState, useEffect } from "react";
import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";


const AssociateBrowseModal = (props) => {
  const {
    open,
    handleClose,
    selectedAssociateId,
    projectsData,
    setPresetHandler,
    prepareConsoleId,
    consoldata,
    workspaceData,
    nature
  } = props;
  const [projects, setProjects] = useState({
    loading: false,
    isSuccess: false,
    response: [],
    error_message: null,
  });
  const [selectedProject, setSelectProject] = useState("default");

  const handleCloseModal = () => {
    handleClose();
    setSelectProject("default");
  }

  useEffect(() => {
    (async () => {
      if (open) {
        if (projectsData) {
          setProjects({
            ...projects,
            loading: false,
            isSuccess: true,
            response: projectsData,
          });
        } else {
          fetchProjects();
        }
      }
    })();
  }, [open]);

  const fetchProjects = async () => {
    if (projects.response.length === 0) {
      setProjects({ ...projects, loading: true });
      try {
        const response = await getProjects();
        console.log("all projects", response);
        setProjects({
          ...projects,
          loading: false,
          isSuccess: true,
          response: response.data.project,
        });
      } catch (err) {
        console.log("error in modal", err);
        setProjects({
          ...projects,
          loading: false,
          isSuccess: false,
          response: err?.response?.data || "Something went Wrong",
        });
      }
    }
  };

  const SubmitPresetValue = async (data) => {
    try {
      if (!selectedProject) return alert("Please select an option");
      const checkProjectValid = await getProjectDetailById(selectedProject);
      console.log(checkProjectValid, "checkProjectValid", consoldata);
      if (data === "Subsidiary Company") {
        if (workspaceData[0]) {
          const validCheck =
            moment(checkProjectValid?.data?.project.current_year).format(
              "DD-MM-YYYY"
            ) === moment(workspaceData[0]?.console_cy).format("DD-MM-YYYY") &&
            moment(checkProjectValid?.data?.project?.previous_year).format(
              "DD-MM-YYYY"
            ) === moment(workspaceData[0]?.console_py).format("DD-MM-YYYY");
          if (validCheck) {
            const response = await updateCompanyData(
              prepareConsoleId,
              selectedProject,
              selectedAssociateId
            );
            if (response.status === 200) {
              const { _id } = projects.response.find(
                (data) => data._id === selectedProject
              );
              setPresetHandler(selectedAssociateId, _id, "Subsidiary Company");
              handleClose();
            }
          } else {
            handleCloseModal();
            swal("", "Upload Correct Preset", "error");
          }
        } else {
          const validCheck =
            moment(checkProjectValid?.data?.project?.current_year).format(
              "DD-MM-YYYY"
            ) ===
            moment(consoldata?.current_financial_year).format("DD-MM-YYYY") &&
            moment(checkProjectValid?.data?.project?.previous_year).format(
              "DD-MM-YYYY"
            ) ===
            moment(consoldata?.previous_financial_year).format("DD-MM-YYYY");
          if (validCheck) {
            const response = await updateCompanyData(
              prepareConsoleId,
              selectedProject,
              selectedAssociateId
            );
            if (response.status === 200) {
              const { _id } = projects?.response?.find(
                (data) => data._id === selectedProject
              );
              setPresetHandler(selectedAssociateId, _id, "Subsidiary Company");
              handleClose();
            }
          } else {
            handleCloseModal();
            swal("", "Upload Correct Preset", "error");
          }
        }
      } else {
        if (workspaceData[0]) {
          const validCheck =
            moment(checkProjectValid?.data?.project.current_year).format(
              "DD-MM-YYYY"
            ) === moment(workspaceData[0]?.console_cy).format("DD-MM-YYYY") &&
            moment(checkProjectValid?.data?.project?.previous_year).format(
              "DD-MM-YYYY"
            ) === moment(workspaceData[0]?.console_py).format("DD-MM-YYYY");
          if (validCheck) {
            const response = await updateCompanyData(
              prepareConsoleId,
              selectedProject,
              selectedAssociateId
            );
            if (response.status === 200) {
              const { _id } = projects.response.find(
                (data) => data._id === selectedProject
              );
              setPresetHandler(selectedAssociateId, _id, "Associate Company");
              handleClose();
            }
          } else {
            handleCloseModal();
            swal("", "Upload Correct Preset", "error");
          }
        } else {
          const validCheck =
            moment(checkProjectValid?.data?.project?.current_year).format(
              "DD-MM-YYYY"
            ) ===
            moment(consoldata?.current_financial_year).format("DD-MM-YYYY") &&
            moment(checkProjectValid?.data?.project?.previous_year).format(
              "DD-MM-YYYY"
            ) ===
            moment(consoldata?.previous_financial_year).format("DD-MM-YYYY");
          if (validCheck) {
            const response = await updateAssociateData(
              prepareConsoleId,
              selectedProject,
              selectedAssociateId
            );
            if (response.status === 200) {
              const { _id } = projects?.response?.find(
                (data) => data._id === selectedProject
              );
              setPresetHandler(selectedAssociateId, _id, "Associate Company");
              handleClose();
            }
          } else {
            handleCloseModal();
            swal("", "Upload Correct Preset", "error");
          }
        }
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  const [selectPresetOpt1, setSelectPresetOpt1] = useState([]);

  useEffect(() => {
    if (projects.isSuccess) {
      if (projects?.response?.length > 0 && projects.response.length > 0) {
        const preset1Opts = projects.response.map((det) => ({
          label: det.project_name,
          value: det._id,
        }));
        setSelectPresetOpt1(preset1Opts);
      }

    }
  }, [projects]);

  return (
    <>
      {open && (
        <Modal
          title="Select COA"
          bodycss={commoncss.unsetPadding}
          headerActions={
            <CloseIcon
              onClick={handleCloseModal}
              className="clickable"
            />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleCloseModal}
                label="Close"
              />
              {projects.isSuccess ? (
                <Button
                  btnColor={buttoncss.primary}
                  label="Save"
                  onClick={() => SubmitPresetValue(nature)}
                />
              ) : (
                <Button
                  btnColor={buttoncss.primary}
                  class_={buttoncss.disabledBtn}
                  label="Save"
                  isEnabled={false}
                />
              )}

            </>
          }
        >
          <div className={commoncss.pd1530}>
            {projects.loading ? (
              "loading..."
            ) : (
              <>
                {projects.isSuccess ? (
                  <>
                    <Dropdown
                      label="Select Preset"
                      options={selectPresetOpt1}
                      onSelect={(opt) => ( setSelectProject(opt.value))}
                      placeHolder={"Select Preset"}
                    />
                  </>
                ) : (
                  <p className="text-danger">
                    {projects?.error_message ?? "Something went wrong"}
                  </p>
                )}
              </>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default AssociateBrowseModal;
